<div class="t-header-search-box">
  <form action="#">
    <div class="input-group">
      <input type="text" class="form-control" id="inlineFormInputGroup" placeholder="Search" autocomplete="off" />
      <button class="btn btn-primary search-submit" type="submit">
        <i class="mdi mdi-arrow-right-thick"></i>
      </button>
    </div>
  </form>
  <div *ngIf="searchService.results.length" class="dropdown-menu navbar-dropdown dropdown-menu-right show" x-placement="bottom-start">
    <div class="dropdown-header">
    <div class="dropdown-body">
      <div class="dropdown-list">
        Search Result
      </div>
    </div>
  </div>
</div>
